export default "__VITE_ASSET__Dmjsn_B6__"